export const grossProfitRangeFromSearch = search => {
  const params = new URLSearchParams(String(search || '').replace(/^\?/, ''))
  const startDate = params.get('from') || ''
  const endDate = params.get('to') || ''
  if (
    !/^\d{4}-\d{2}-\d{2}$/.test(startDate) ||
    !/^\d{4}-\d{2}-\d{2}$/.test(endDate)
  )
    return null
  if (startDate > endDate) return null
  return { startDate, endDate }
}

export const venueGrossProfitPath = (venueId, range) => {
  if (!venueId || !range?.fromDate || !range?.toDate) return ''
  const query = new URLSearchParams({ from: range.fromDate, to: range.toDate })
  return `/v/${venueId}/purchasing/gross-profit?${query}`
}
